import { css, useTheme } from "@emotion/react"
import {
  breakpoints,
  colorPrimatives,
  fontFamilies,
  fontSizes,
  mediaQueries,
} from "../styles/theme"

const ArticleContainer = ({ children }) => (
  <article
    css={css`
      margin: auto;
      padding: 0 32px;
      ${mediaQueries.md} {
        border-left: 1px solid ${colorPrimatives.tumbleweed};
        border-right: 1px solid ${colorPrimatives.tumbleweed};
      }
    `}
  >
    {children}
  </article>
)

export default ArticleContainer
